import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogRef, SimpleDialogData } from '@ddt-web/dialog';
import { DialogIcon } from '@ddt-web/domain';
import { StoreService } from '@ddt-web/store-service';
import { UrlService } from '@ddt-web/url';
import { PartnerConstants } from '@ddt-web/user-data';
import * as get from 'lodash/get';


@Component({
	templateUrl: './reimport-dialog.component.html',
	styleUrls: ['./reimport-dialog.component.scss']
})

export class ReimportDialogComponent implements OnInit {
	public dialogData: SimpleDialogData = {} as SimpleDialogData;
	public imagePath: string;
	public shouldHideLoadAcVersion: boolean = false;


	constructor(
		public dialogRef: DialogRef,
		public config: DialogConfig,
		private storeService: StoreService,
		private urlService: UrlService
	) {
		this.shouldHideLoadAcVersion = get(this.config, 'data.shouldHideLoadAcVersion', false);
	}

	public ngOnInit(): void {
		if (this.dialogData) {
			this.imagePath = DialogIcon.EXCLAMATION_TRIANGLE;
		}

	}
	public reimportPortfolio(): void {
		const storeConfig = get(this.config, 'data.storeConfig.associatedPortfolios');
		const portfolioId = get(this.config, 'data.portfolioId');
		const customCallbackFunction: Function = get(this.config, 'data.customCallback');

		if (customCallbackFunction) {
			customCallbackFunction();
			this.dialogRef.close();
			return;
		}

		if (storeConfig && portfolioId) {
			this.storeService.removeMany(storeConfig, [portfolioId]);
			this.urlService.addQueryParamAndReload(PartnerConstants.PARTNER_REIMPORT_QUERY_PARAM, 'true');
		}
	}

	public loadACVersion(): void {
		this.dialogRef.close();
	}

}
